export default "__VITE_ASSET__3b8e0b2e__"